import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { AdvancedPageComponent } from './advanced.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: AdvancedPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class AdvancedPageRoutingModule {}
